import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { App1Component } from './app1.component';
import { App2Component } from './app2.component';

@NgModule({
  imports:      [ BrowserModule, FormsModule ],
  declarations: [ App1Component, App2Component ],
  bootstrap:    [ App1Component, App2Component ],
  schemas:      [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }